import * as React from 'react';
type Props = {
  className?: string;
};
export function BellPepper({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Bell Pepper"
      className={className}
    >
      <path
        d="M19.92 9.88C20.5442 9.86626 21.1662 9.95755 21.7601 10.15L21.85 2.53003H18.42L18.3301 10.29C18.8355 10.0714 19.3719 9.93308 19.92 9.88V9.88Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M17.14 33.8C16.21 32.07 14.52 29.3699 13.82 18.6999C13.7122 16.566 14.3134 14.4564 15.53 12.6999C16.1507 11.7058 17.0375 10.9056 18.09 10.39L18.44 10.25C17.3112 9.47804 16.0033 9.00837 14.6412 8.88582C13.2792 8.76327 11.9085 8.99199 10.66 9.55001C8.02998 10.88 7.79 13.8599 7.55 16.8299C7.22 20.9899 8.39002 24.21 9.82002 28.03C10.67 30.29 12.67 36.03 14.11 37.03C14.4844 37.2052 14.8877 37.3102 15.3 37.3399C16.4989 37.3534 17.6603 36.9224 18.56 36.13C18.6941 36.018 18.821 35.8978 18.94 35.77C18.1566 35.308 17.5297 34.6218 17.14 33.8V33.8Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M32.66 15.88C32.1 12.94 31.55 9.99002 28.79 8.88002C27.5322 8.43267 26.1824 8.30718 24.8637 8.51503C23.545 8.72288 22.2992 9.25741 21.24 10.07C21.7159 10.1671 22.1744 10.3357 22.6 10.57C24.49 11.57 25.21 13.7801 25.6 14.8001C27.36 20.1701 26.1 32.0601 23.1 35.3001C23.3083 35.5304 23.5433 35.7352 23.8 35.9101C24.7679 36.6426 25.9693 36.9981 27.18 36.9101C27.584 36.8457 27.9733 36.7103 28.33 36.51C29.55 36 31.04 29.58 31.65 27.26C32.62 23.24 33.44 19.94 32.66 15.88Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M19.92 9.88002C20.8515 9.85502 21.774 10.0684 22.6 10.5C24.49 11.5 25.21 13.71 25.6 14.73C27.51 20.55 25.87 34.04 22.3 35.87C21.3467 36.2619 20.2779 36.2647 19.3226 35.8777C18.3674 35.4907 17.6018 34.7449 17.19 33.8001C16.26 32.0701 14.57 29.37 13.87 18.7C13.7622 16.5661 14.3635 14.4564 15.58 12.7C16.2007 11.7058 17.0876 10.9056 18.14 10.39C18.6964 10.1107 19.3001 9.93772 19.92 9.88002V9.88002Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
